export enum SearchType {
    awb = 'awb',
    flight = 'flight',
}
